export default import.meta.ROLLDOWN_FILE_URL_fga___UE0TaKOtsCwWAPAA